/**
 * confirm-unsaved-editor.js
 */

import React from 'react';
import ConfirmRouteChange from 'routing/confirm-route-change';

export default function ConfirmUnsavedEditor(props) {
  const {
    dirty,
    save,
    discard,
  } = props;

  return (
    <>
      <ConfirmRouteChange
        when={dirty}
        shouldBlockNavigation={() => dirty}
        title="Save Changes?"
        titleIcon="info"
        content="You haven't saved. Are you sure you want to discard your current changes?"
        okText="Discard Changes"
        cancelText="Cancel"
        save={save}
        navAction={discard}
      />
    </>
  );
}